import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { MultiDateSelector } from "@/Common/Components/Inputs/MultiDateSelector";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { PatientRecallsListItem } from "@/Patient/Models/History/PatientRecallsListItem";
import { IPatientRecallsModel } from "@/Patient/Models/UI/History/IPatientRecallsModel";
import { RecallNewEntryPopup } from "./RecallNewEntryPopup";

interface IPatientHistoryRecallsProps {
    Model: IPatientRecallsModel;
}

interface IRecallsViewState {
    isLoading: boolean;
}

class RecallsView extends React.Component<IPatientHistoryRecallsProps, IRecallsViewState> {
    constructor(props: IPatientHistoryRecallsProps) {
        super(props);
        this.state = {
            isLoading: false
        };
    }

    public componentDidMount(): void {
        sessionStore.dispatchAsync(LocalPatientOperations.History.Recall_LoadPatientRecall);

        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        var recallsModel: IPatientRecallsModel;
        if (this.props.Model)
            recallsModel = this.props.Model;

        return (
            <div className="medical-summary-container">
                <div className="tb medical-summary">
                    {this.leftSide(recallsModel)}
                    {recallsModel.get("ShowDetails") === true && this.rightSide(recallsModel)}
                    {recallsModel.get("ShowDetails") === false && this.emptyRightSide()}
                </div>
            </div>
        );
    }

    private leftSide(model: IPatientRecallsModel): JSX.Element {
        var toggleIconCss = "toggle-icon2";
        if (this.props.Model.get("ShowOnlyNotCompleted")) {
            toggleIconCss += " active";
        }

        return (
            <div className="fxheight tbc full-border left-primary">
                <div className="note-search">
                    <div className="search-field">
                        <div className="gf">
                            <span className="glyphicon glyphicon-search" />
                        </div>
                        <TextboxControl debounceMs={400} value={model.get("SearchText")} className="fullWidth" operation={LocalPatientOperations.History.Recall_SearchText} placeholder={cacheStore.GetString("SearchLabel")} />
                    </div>
                    {model.get("IsCriteriaExpanded") === true && (
                        <div className="margin-sm-top">
                            <MultiDateSelector
                                id="doc_search_date_selector"
                                fullWidth={true}
                                fromMyleOperation={LocalPatientOperations.History.Recall_FromDateChanged}
                                toMyleOperation={LocalPatientOperations.History.Recall_ToDateChanged}
                                fromSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                toSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                from={model.get("DateFrom")}
                                to={model.get("DateTo")}
                            />
                        </div>
                    )}
                    <div className="clearfix margin-md-top">
                        <span style={{ marginRight: "7px" }} className={toggleIconCss} onClick={this.toggleDisplayMode.bind(this)} />
                        {model.get("IsCriteriaExpanded") === true && <a className="pull-right" onClick={this.ShowCriteria.bind(this)}>[-]{cacheStore.GetString("CriteriaLabel")}</a>}
                        {model.get("IsCriteriaExpanded") === false && <a className="pull-right" onClick={this.ShowCriteria.bind(this)}>[+]{cacheStore.GetString("CriteriaLabel")}</a>}
                    </div>
                </div>
                {this.recallList(model)}
            </div>
        );
    }

    private recallList(model: IPatientRecallsModel): JSX.Element {
        var recallsList = model.get("RecallsList");
        var recallsRender = recallsList.map((recalls: PatientRecallsListItem) => (
            <div className="pointer" key={"__a" + recalls.Model.RecallId} onClick={this.setSelectedRecall.bind(this, recalls)}>
                <div className="med-note">
                    <div className="tb">
                        <div className="tbc">
                            <p className="ellipsis"><strong>{recalls.Model.Type}</strong></p>
                            <p><span>{recalls.Model.To}</span></p>
                        </div>
                        <div className="tbc text-right">
                            <p><span>{recalls.Model.DueDate}</span></p>
                            {recalls.Model.IsCompleted === false && (
                                <ul className="clearfix circles pull-right padding-xs-top">
                                    <span className="circle" style={{ width: "15px", height: "15px" }}><i /></span>
                                </ul>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        ));
        return (
            <div data-hvar="40" className="note-collection scrollable" data-cy="recallsView-recallItems">
                {recallsRender}
            </div>
        );
    }

    private rightSide(model: IPatientRecallsModel): JSX.Element {
        var hvarValue = model.get("IsCompleted") ? "0" : "60";

        return (
            <div className="tbc right-primary">
                <div className="summary-container">
                    {model.get("ShowNewEntryPopup") === true &&
                        <RecallNewEntryPopup Model={this.props.Model} />
                    }
                    <div className="banner">
                        <label>{cacheStore.GetString("RecallLabel")}</label>
                        <h3 className="thin-font ellipsis-auto" title={model.get("Description")} style={{ maxWidth: "40vw" }}>{model.get("Description")}</h3>
                    </div>
                    {model.get("IsCompleted") === false && <div className="pull-right padding-sm-top margin-xs-right" />}

                    <div data-hvar={hvarValue} className="myle-form no-x-overflow scrollable padding-sm-top" data-cy="recallsView-information">
                        <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("DescriptionLabel")}</label>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 form-field-answer ellipsis-auto" style={{ maxWidth: "40vw" }}>
                                <strong title={model.get("Description")}>{model.get("Description")}</strong>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("ProviderDocLabel")}</label>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 form-field-answer">
                                <strong>{model.get("Provider")}</strong>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("SpecializationLabel")}</label>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 form-field-answer">
                                <strong>{model.get("Speciality")}</strong>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("DueDateLabel")}</label>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 form-field-answer">
                                <strong>{model.get("DueDate")}</strong>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("CreatedByLabel")}</label>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 form-field-answer">
                                <strong>{model.get("CreatedBy")}</strong>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("PriorityLabel")}</label>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 form-field-answer">
                                <strong>{model.get("Priority")}</strong>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("NotesLabel")}</label>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 form-field-answer">
                                <strong>{model.get("Notes")}</strong>
                            </div>
                        </div>
                        {this.renderCommunicationHistory(model)}
                    </div>
                    {model.get("IsCompleted") === false && (
                        <div className="meta-footer flex-display flex-end flex-align-items-center" style={{ paddingTop: 0 }}>
                            <ButtonGroup>
                                <ButtonControl
                                    variant="brand"
                                    onClick={() => sessionStore.dispatch(LocalPatientOperations.History.Recall_AddNewEntry)}
                                    label={cacheStore.GetString("NewEntryLabel")}
                                />
                                <ButtonControl
                                    variant="brand"
                                    onClick={() => this.markRecallAsCompleted()}
                                    disabled={this.state.isLoading}
                                    label={cacheStore.GetString("MarkRecallAsCompletedLabel")}
                                    dataCy="recallsView-markRecallAsCompleted"
                                />
                            </ButtonGroup>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    private renderCommunicationHistory(model: IPatientRecallsModel): JSX.Element {
        let communicationList = model.get("RecallCommunication");
        if (!communicationList || communicationList.count() < 1)
            return null;

        let communicationRender = communicationList.map(communication => {
            const noteLinesJsx: JSX.Element[] = communication.Model.Notes?.length > 0
                ? communication.Model.Notes
                    .split("\n")
                    .map((note, index) => <div key={`${communication.Model.Id} ${note} ${index}`}><span>{note}</span><br /></div>)
                : [];

            return (
                <div key={communication.Model.Id} style={{ paddingBottom: "15px" }}>
                    <div>
                        <strong>
                            <span>{communication.Model.Employee}</span>
                            <span className="separator">{cacheStore.GetString("OnLabel")}</span>
                            <span>{communication.Model.DateCreated}</span>
                            {communication.Model.State && (
                                <span className="separator">|</span>
                            )}
                            <span className="logo-color">{communication.Model.State}</span>
                        </strong>
                    </div>
                    <div className="bottom-border margin-xs-top">
                        {noteLinesJsx}
                    </div>
                </div>
            );
        });

        return (
            <div className="row">
                <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                    <label className="form-label">{cacheStore.GetString("CommunicationHistoryLabel")}</label>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 form-field-answer">
                    {communicationRender}
                </div>
            </div>
        );
    }

    private emptyRightSide(): JSX.Element {
        return (
            <div className="tbc right-primary">
                <div className="scrollable">
                    <div className="summary-container no-border" />
                </div>
            </div>
        );
    }

    public componentDidUpdate(): void {
        $(window).trigger("resize");
    }

    public setSelectedRecall(recall: PatientRecallsListItem): void {
        this.setState({ isLoading: false });
        sessionStore.dispatch(LocalPatientOperations.History.Recall_ShowSelectedRecall, { recall: recall });
    }

    public ShowCriteria(): void {
        sessionStore.dispatch(LocalPatientOperations.History.Recall_CriteriaClick);
    }

    private toggleDisplayMode(): void {
        LocalEvent.Dispatch(LocalPatientOperations.History.Recall_ShowOnlyNotCompleted);
    }

    private async markRecallAsCompleted(): Promise<void> {
        this.setState({ isLoading: true });

        sessionStore.dispatchAsync(LocalPatientOperations.History.Recall_MarkRecallAsCompleted);
    }
}

export { IPatientHistoryRecallsProps, RecallsView };
